/* global Sys, Core, Services */
Sys.ns("Core.Slots");

/**
 * The Free Rounds module.
 *
 * Handles the Free Rounds feature.
 *
 * @class Core.Slots.FreeRounds
 * @extends Core.Module
 */
Core.Slots.FreeRounds = {

    constructor: function() {
        Core.Slots.FreeRounds.superclass.constructor.apply(this, arguments);
    },

    /**
     * @protected
     * @inheritdoc
     */
    getStateChanges: function() {
        var model = this.model;

        return {
            beforeLoaderClose: {
                queue: [
                    function(env) {
                        if (Services.freeRounds.getRemaining() > 0 && !model.readData("hasShownSplash")) {
                            env.stateHandler.pushState(env.states.freeRoundsDialog);
                        }
                    }
                ]
            },
            stopped: {
                queue: [
                    function(env) {
                        if (Services.freeRounds.isActive() && Services.freeRounds.getRemaining() === 0) {
                            env.stateHandler.pushState(env.states.checkForAdditionalFreeRounds);
                        }
                    }
                ]
            },
            checkForAdditionalFreeRounds: {
                state: {
                    name: "CheckForAdditionalFreeRounds",
                    execute: function() {
                        // stub
                    },
                    waitEvents: {
                        "notify:responseParser.gameConfigurationParsed": false
                    }
                }
            },
            freeRoundsDialog: {
                state: {
                    name: "FreeRoundsDialog",
                    execute: function() {
                        // stub
                    },
                    waitEvents: {}
                }
            }
        };
    },

    /**
     * @protected
     * @inheritdoc
     */
    getDefaultMVCClasses: function() {
        return {
            model: Core.Slots.FreeRoundsModel,
            controller: Core.Slots.FreeRoundsController
        };
    }
};

Core.Slots.FreeRounds = Sys.extend(Core.Module, Core.Slots.FreeRounds, "Core.Slots.FreeRounds");
